import { mapItemList } from './parsers/items';
import { toError } from './parsers/error';
import { flatten, times } from 'ramda';
export const initItems = (settings, http) => {
  function getThumbnails(items, limit) {
    return function (index) {
      const chunkItems = (items.data || []).slice(index * limit, (index + 1) * limit);
      return http.post("" + settings.apiUrl + settings.apiPath + "/get_thumbnail_batch", {
        paths: chunkItems.map(item => item.pathLower)
      }, null, {
        withCredentials: true
      }).then(thumbs => thumbs.data);
    };
  }
  async function embedThumbnails(items) {
    const thumbsRequestLimit = 25;
    const requestNumber = Math.ceil(items.data.length / thumbsRequestLimit);
    const thumbnailArrays = await Promise.all(times(getThumbnails(items, thumbsRequestLimit), requestNumber));
    const thumbnails = flatten(thumbnailArrays.map(t => t.entries));
    return {
      ...items,
      data: (items.data || []).map((item, index) => ({
        ...item,
        thumbnailUrl: thumbnails[index] && thumbnails[index]['.tag'] === 'success' && "data:image/jpeg;base64," + thumbnails[index].thumbnail
      }))
    };
  }
  function list(folderId, options) {
    options = options || {};
    options.paging = options.paging || {};
    const requestOptions = {
      album_id: folderId || null,
      cursor: options.paging.cursor || null
    };
    return http.get("" + settings.apiUrl + settings.apiPath + "/files", requestOptions, {
      withCredentials: true
    }).then(result => mapItemList(result, settings), toError).then(embedThumbnails);
  }
  return {
    list
  };
};